import axios from 'axios';
import store from '@/store/'


// Account 相關的 api
const accountRequest = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN+'/account'
});

//登入API
export const apiAccountLogin = data => accountRequest.post('/login', data);
//狀態API
export const apiAccountStatus = (data) => accountRequest.get('/status',{
    params : data,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});

//修改密碼API
export const apiAccountUpdatePassword = (data,params) => accountRequest.put('/password',data,{
    params : params,
    headers:{
        'Authorization': `Bearer ${store.state.auth.accessToken}`
    }
});